export * from './text-inline-image-section-wrapper'
